import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
} from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase.config';
import { toast } from 'react-toastify';
import ButtonForm from '../components/ButtonForm';
import GoogleBox from '../components/GoogleBox';

function Register() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });

  const { name, email, password } = formData;

  const navigate = useNavigate();

  const onChange = e => {
    setFormData(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async e => {
    e.preventDefault();

    try {
      const auth = getAuth();

      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      const user = userCredential.user;

      updateProfile(auth.currentUser, { displayName: name });

      const formDataCopy = { ...formData };
      delete formDataCopy.password;
      formDataCopy.timestamp = serverTimestamp();

      await setDoc(doc(db, 'users', user.uid), formDataCopy);

      navigate('/my-library');
    } catch (error) {
      toast.error('Something went wrong with registration');
    }

    setFormData({
      name: '',
      email: '',
      password: '',
    });
  };

  return (
    <form className="form" onSubmit={onSubmit}>
      <div className="form__control u-margin-bottom-m">
        <h4 className="heading-4">Name</h4>

        <input
          type="text"
          name="name"
          id="name"
          className="form__input"
          value={name}
          required
          onChange={onChange}
        />
      </div>

      <div className="form__control u-margin-bottom-m">
        <h4 className="heading-4">E-Mail</h4>

        <input
          type="email"
          name="email"
          id="email"
          className="form__input"
          value={email}
          required
          onChange={onChange}
        />
      </div>

      <div className="form__control u-margin-bottom-xl">
        <h4 className="heading-4">Password</h4>

        <input
          type="password"
          name="password"
          id="password"
          className="form__input"
          value={password}
          required
          onChange={onChange}
        />
      </div>

      <div className="form__control u-margin-bottom-m">
        <ButtonForm />
      </div>

      <GoogleBox />
    </form>
  );
}

export default Register;
